import { UseMutationResult, useMutation } from 'react-query';
import {
  CompanySsoConfigurationService,
  Wealthlane_Dtos_SsoProvider_UpdateSsoConfigurationSigningCertificateDto,
} from '../../services/wealthlane-identity-services';
import { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../../services/wealthlane-award-services';

const usePostUpdateSigningCertificate = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  onSuccess: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  any,
  unknown
> => {
  return useMutation(
    async (payload?: Wealthlane_Dtos_SsoProvider_UpdateSsoConfigurationSigningCertificateDto) => {
      const response = await handleRequest(
        CompanySsoConfigurationService.postApiIdentityApiAppCompanySsoConfigurationUpdateSigningCertificate(
          payload
        )
      );
      return response;
    },
    {
      onSuccess: () => {
        onSuccess();
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostUpdateSigningCertificate;
